import React, { Suspense, VFC } from "react";
import { Redirect, Switch } from "react-router-dom";
import { GroupType } from "../domain/group/group-type";
import { AuthenticatedRoute } from "../utils/AuthenticatedRoute";
import { AvailablePomRoutes } from "../utils/constants";
import { PomAgencyPage } from "../pages/agency/pom-agency.page";
import { PomReportingPage } from "../pages/announcement/pom-reporting.page";
import { Loading } from "../components/loading/loading.component";

export const PomRoutes: VFC = () => {
  return (
    <Suspense fallback={<Loading isLoading={true} />}>
      <Switch>
        <Redirect path={AvailablePomRoutes.Portal} exact to={AvailablePomRoutes.Reporting} />
        <AuthenticatedRoute
          allowedRoles={[
            GroupType.Customer,
            GroupType.PomRepresentative,
            GroupType.PomAgency,
            GroupType.PomAgencyMember,
          ]}
          path={AvailablePomRoutes.Reporting}
          exact
          component={PomReportingPage}
        />

        {/*Agency*/}
        <AuthenticatedRoute
          allowedRoles={[GroupType.PomAgency]}
          path={AvailablePomRoutes.Agency}
          exact
          component={PomAgencyPage}
        />

        <Redirect path="*" to={AvailablePomRoutes.Portal} push />
      </Switch>
    </Suspense>
  );
};
